import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconKey16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.682 7.621 3.03 1.97 1.97 3.03l.97.97-1.47 1.47 1.06 1.06L4 5.06l.94.94-1.47 1.47 1.06 1.06L6 7.06l1.621 1.622a3.75 3.75 0 1 0 1.06-1.06M13 10.751a2.25 2.25 0 1 1-4.5-.001 2.25 2.25 0 0 1 4.5 0",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconKey16);
export default ForwardRef;
